import React from 'react'

export default ({ color }) => (
  <svg viewBox="0 0 14 25">
    <path fill={color} d="M13.7,0.3L0.3,12.5l13.4,12.2L13.7,0.3z" />
  </svg>
)
